import { render, staticRenderFns } from "./AmountSectionalDoor.vue?vue&type=template&id=5bfa5564&"
import script from "./AmountSectionalDoor.vue?vue&type=script&lang=ts&"
export * from "./AmountSectionalDoor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports